import { makeStyles } from '@mui/styles';
import { useMediaQuery } from '@mui/material';

import clsx from 'clsx';

const useStyle = makeStyles(() => ({
  '@global': {
    '@keyframes loading9-ani1': {
      '100%': {
        transform: 'translate(30px)',
        opacity: '0',
      },
    },
    '@keyframes loading9-ani2': {
      '100%': {
        transform: 'translate(20px)',
        opacity: '1',
      },
    },
    '@keyframes loading9-ani3': {
      '100%': {
        transform: 'translate(20px)',
      },
    },
  },

  bodyLoading: {
    display: 'table-header-group',
    height: '74%',
    width: '99%',
    position: 'absolute',
    margin: 'auto',
    zIndex: '1000',
    left: 0,
    top: '66px',
    right: 0,
    background: '#ffffffc7',
    '&.tableLoading': {
      height: '80%!important',
      top: '68px',
    },
    '&.bodyPageLoading': {
      position: 'relative',
      minHeight: '64vh',
    },
    '@media(max-width: 500px)': {
      height: '69%',
      width: '97%',
    },
  },

  loadingBlock: {
    textAlign: 'center',
    margin: 'auto',
    transform: 'translate(-50%, 0)',
    position: 'absolute',
    top: '40%',
    left: '50%',
  },
  loading: {
    width: '140px',
    display: 'flex',
    gap: '5px',
    margin: 'auto',
    justifyContent: 'center',
    textAlign: 'center',

    '& i': {
      width: '12px',
      height: '12px',
      display: 'inline-block',
      borderRadius: '50%',
      background: '#2b3990',
      '&:first-child': {
        animation: 'loading9-ani2 0.5s linear infinite',
        opacity: '0',
        transform: 'translate(-20px)',
      },
      '&:nth-child(2) , &:nth-child(3)': {
        animation: 'loading9-ani3 0.5s linear infinite',
      },
      '&:last-child': {
        animation: 'loading9-ani1 0.5s linear infinite',
      },
    },
  },
}));

export default function NewLoading({ type , styleLoadingDialog }) {
  const classes = useStyle();
  const matches = useMediaQuery('(max-width:600px)');
  const y = '-70px';
  return (
    <div className={clsx(classes.bodyLoading, type === 'pages' ? 'bodyPageLoading' : type === 'table' ? 'tableLoading' : '')} style={{
      transform: type === 'pages' ? `translateY(${y}) scale(${matches ? '1' : '1'}) ` : 'inherite','height':styleLoadingDialog ? "81%" : "74%",
    }} width={matches ? 'unset' : '700px'}
      height={matches ? 'unset' : '700px'}>
      <div className={classes.loadingBlock} style={{
        top: type === 'pages' ? '45%' : '40%',
        
      }}>
        <div className={classes.loading}>
          <i></i>
          <i></i>
          <i></i>
          <i></i>
        </div>
      </div>
    </div>
  );
}